module.exports = __webpack_public_path__ + "static/media/mobility-ecosystem-icon.2e1ec432.svg";